import PageHero from '../shared/PageHero.jsx';
import StatBand from '../shared/StatBand.jsx';
import Reveal from '../shared/Reveal.jsx';
import Seo from '../seo/Seo.jsx';
import { metaFor } from '../seo/routes.js';
import { achievementStats, honours } from '../constants/achievements.js';

export default function Achievements() {
  return (
    <>
      <Seo {...metaFor('/achievements')} path="/achievements" />

      <PageHero
        eyebrow="Achievements"
        title="What eighteen children in a room adds up to."
      />

      <StatBand stats={achievementStats} />

      <section className="bg-cream pb-20 pt-[70px]">
        <div className="mx-auto max-w-[1240px] px-5 sm:px-8">
          <Reveal
            as="h2"
            className="font-display text-4xl font-extrabold leading-[1.05] text-forest"
          >
            Recent honours
          </Reveal>

          <ol className="mt-6.5 flex flex-col gap-3.5">
            {honours.map((honour, i) => (
              <Reveal
                as="li"
                key={honour.title}
                index={i}
                className="flex flex-wrap items-center gap-5 rounded-[22px] border-2 border-line bg-white px-6 py-5"
              >
                <p className="w-16 flex-none font-display text-xl font-extrabold text-coral">
                  {honour.year}
                </p>
                <div className="min-w-[240px] flex-1">
                  <h3 className="text-lg font-extrabold text-ink">{honour.title}</h3>
                  <p className="mt-0.5 text-[15px] text-ink-soft">{honour.detail}</p>
                </div>
                <p className="rounded-full bg-mint px-3.5 py-[7px] text-sm font-bold text-forest">
                  {honour.tag}
                </p>
              </Reveal>
            ))}
          </ol>
        </div>
      </section>
    </>
  );
}
